require("react");
import cookies from 'next-cookies';
import Link from "next/link";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import MainLayout from "../Layouts/MainLayout";
import ChangePhoneNumber from '../view/ChangeEmailPhoneNumber/ChangePhoneNumber/ChangePhoneNumber';
import ChangeEmail from '../view/ChangeEmailPhoneNumber/ChangeEmail/ChangeEmail';
import MainButton from "../components/ButtonsCont/MainButton";
import TextInput from "../components/TextInput/TextInput";
import SelectOption from "../components/TextInput/SelectOption";
import Autocomplete from '../components/Autocomplete/Autocomplete';
import SwitchCont from "../components/Switch/SwitchCont";
import hooks from "../hooks/myInfoHooke";
import generalHooks from "../hooks/general";
import validation from "../utils/validation";
import fileReader from "../utils/fileReader";
// import Select from '@material-ui/core/Select';
// import CircularProgress from '@mui/material/CircularProgress';
// import { TextField } from '@material-ui/core';
// import FilledInput from '@material-ui/core/FilledInput';
import translate_word from "../utils/translate";
import styles from '../styles/myProfile.module.scss';
import { wrapper } from '../store';
import ChangePassword from '../view/ChangePassword/ChangePassword';
import SetPassword from '../view/ChangePassword/SetPassword';
export const getServerSideProps = wrapper.getServerSideProps(async (ctx) => {
    const { token } = cookies(ctx);
    if (!token) {
        return {
            props: {
                ...(await serverSideTranslations(ctx.locale, ["common"])),
                loggedIn: false,
                language: ctx.locale
            }
        };
    } else {
        // await ctx.store.dispatch(get_country_saga({ country: user.city_details ? user.city_details.country : "" }));
        // await ctx.store.dispatch(END);
        return {
            props: {
                ...(await serverSideTranslations(ctx.locale, ["common"])),
                token,
                loggedIn: true,
                language: ctx.locale
            }
        };
    }
});
function MyProfile(props) {
    const {
        user,
        edit,
        router,
        open,
        openPhone,
        translate,
        openCity,
        sendEmail,
        handleSendEmail,
        get_inputs_values_act,
        edit_my_data,
        set_file,
        keyPress,
        setOpen,
        setOpenPhone,
        log_out,
        setOpenCity
    } = hooks(props);
    const {
        city_data,
        country_data,
        gender_data,
        get_city
    } = generalHooks();
    const { t } = useTranslation();
   
    return (
        // <div className="App"> 
        <MainLayout meta={`${edit.data.first_name} ${edit.data.last_name}`}
            title={`${edit.data.first_name} ${edit.data.last_name}`}
            token={props.token} id={user ? user.id : ""}
            language={props.language}
            user_image={user ? user.image : ""}>
            <main className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link
                            as={`/${props.language}`}
                            href={`/${props.language}`}>
                            <a>{t("main")}</a>
                        </Link>
                        </li>
                        <li className="breadcrumb-item active"
                            aria-current="page">{t("personal_area")}</li>
                    </ol>
                </nav>
                <div className={`d-flex ${styles.subMenu}`}>
                    <Link href={`/${props.language}/payment-cards`} as={`/${props.language}/payment-cards`}>
                        <a className={styles.menu_item}>{t("paymentCardLabel")}</a>
                    </Link>
                    <Link href={`/${props.language}/chats`} as={`/${props.language}/chats`} >
                        <a className={styles.menu_item}>{t("messagesLabel")}</a>
                    </Link>
                    <Link href={`/${props.language}/my-notes?type=incomings`} as={`/${props.language}/my-notes?type=incomings`} >
                        <a className={styles.menu_item}>{t("myNotesLabel")}</a>
                    </Link>
                    <Link href={`/${props.language}/reviews?type=1`} as={`/${props.language}/reviews?type=1`} >
                        <a className={styles.menu_item}>{t("reviewsLabel")}</a>
                    </Link>
                </div>
                {edit.data.username ? <div className="d-flex flex-column flex-md-row">
                    <ChangeEmail
                        token={props.token}
                        open={open}
                        setValue={() => setOpen(!open)}
                    />
                    <ChangePhoneNumber
                        token={props.token}
                        open={openPhone}
                        setValue={() => setOpenPhone(!openPhone)}
                    />
                    {/* <Modal
                        open={open_report}
                        onClose={() => setOpenReport(false)}
                        aria-labelledby="simple-modal-title" 
                        aria-describedby="simple-modal-description"
                    >
                        {body_report}
                    </Modal> */}
                    <div className={styles.my_profile}>
                        <div className={styles.profile_log_out}>
                            <img className={styles.profile_img}
                                src={edit.data.image
                                    ? edit.data.image
                                    : "/profile-user.svg"} />
                            <div className={styles.log_out} onClick={() => {
                                log_out();
                                router.push("/");
                                document.cookie = `token=; path=/`;
                                document.cookie = `user_id=; path=/`;
                                document.cookie = `lat=; path=/`;
                                document.cookie = `lng=; path=/`;
                                document.cookie = `room=; path=/`;
                                document.cookie = `chat_master=; path=/`;

                            }}>
                                <i className="icon-log-out"></i>
                                <span>{t("logoutLabel")}</span>
                            </div>
                        </div>
                        <label className={styles.prf_image_input}>
                            {/* <MainButton title="Сменить фото" onClick={() => console.log("hhhh")} /> */}
                            <div className={styles.edit_image}>{t("changePhotoLabel")}</div>
                            <input type="file" onChange={(e) => {
                                let image = fileReader(e);
                                if (image && image.type.includes("image")) {
                                    set_file({ cb: get_inputs_values_act, image });
                                }
                                // get_inputs_values_act({ label: "image", data: image })
                            }} />
                        </label>
                        <div className="d-none d-md-flex">
                            <div className={styles.log_out} onClick={() => {
                                log_out();
                                router.push("/");
                                document.cookie = `token=; path=/`;
                                document.cookie = `user_id=; path=/`;
                                document.cookie = `lat=; path=/`;
                                document.cookie = `lng=; path=/`;
                                document.cookie = `room=; path=/`;
                                document.cookie = `chat_master=; path=/`;
                            }}><i className="icon-log-out"></i><span>{t("logoutLabel")}</span></div>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-center my-profile">
                        <div className="d-flex flex-column flex-xl-row w-100 w-md-content">
                            <div className="d-flex flex-column">
                                <TextInput label={t("nameLabel")} type="text"
                                    onKeyDown={(e) => keyPress(e)}
                                    value={edit.data.first_name}
                                    onChange={(value) => {
                                        get_inputs_values_act({
                                            label: "first_name",
                                            data: validation({ value, type: "text" })
                                        });
                                    }} />
                                <TextInput label={t("surnameLabel")} type="text"
                                    onKeyDown={(e) => keyPress(e)}
                                    value={edit.data.last_name}
                                    onChange={(value) => {
                                        get_inputs_values_act({
                                            label: "last_name",
                                            data: validation({ value, type: "text" })
                                        });
                                    }}
                                />
                                {/* <TextInput label={translate.login_forget} type="text"
                                    onKeyDown={(e) => keyPress(e)}
                                    value={edit.data.username}
                                    disabled={true}
                                    onChange={(value) => {
                                        get_inputs_values_act({ label: "username", data: validation({ value, type: "text" }) })
                                    }}
                                /> */}
                                <SelectOption
                                with_icon={false}
                                    language={props.language}
                                    label={t("genderLabel")}
                                    value={edit.data.gender ?
                                        edit.data.gender : ""}
                                    list={gender_data.gender.results}
                                    handleChange={(e) => {
                                        get_inputs_values_act({
                                            label: "gender",
                                            data: { value: e.target.value }
                                        });
                                    }}
                                />
                                <TextInput label={t("birthDayLabel")}
                                    type="date"
                                    onKeyDown={(e) => keyPress(e)}
                                    value={edit.data.birth_date}
                                    onChange={(value) => {
                                        get_inputs_values_act({
                                            label: "birth_date",
                                            data: validation({ value, type: "text" })
                                        });
                                    }}
                                />
                               { user.password_is_null?<SetPassword token={props.token}/> :<ChangePassword token={props.token}/>}
                            </div>
                            <div className="line d-md-none d-flex w-100" />
                            <div className="d-flex flex-column w-100 w-md-content">
                                {/* <div className={styles.edit_email_phone}> */}
                                <div className={styles.auto_complete}>
                                    <Autocomplete
                                        language={props.language}
                                        loading={city_data.loading}
                                        value={city_data.city.search}
                                        list={city_data.city.results}
                                        label={t("yourCityLabel")}
                                        selected={translate_word(edit.data.city_details, props.language)}
                                        onSelect={(value) => {
                                            if (value) {
                                                get_inputs_values_act({
                                                    label: "city_details",
                                                    data: { value: value }
                                                });
                                            } else {
                                                get_inputs_values_act({
                                                    label: "city_details",
                                                    data: {
                                                        value: {
                                                            city: null,
                                                            country: null,
                                                            departement: null,
                                                            latitude: "",
                                                            logitude: "",
                                                            title_en: "",
                                                            title_fr: ""
                                                        }
                                                    }
                                                });
                                            }
                                        }}
                                        onChange={(value) => {
                                            get_city({ search: value });
                                        }}

                                    />
                                </div>
                                <div className={styles.edit_email_phone}>
                                    <TextInput
                                        label={t("emailAddressLabel")}
                                        type=""
                                        value={edit.data.email}
                                        readOnly={true}
                                        onKeyDown={(e) => keyPress(e)}
                                        disabled={true}
                                        onChange={(value) => {
                                            get_inputs_values_act({
                                                label: "email",
                                                data: validation({ value, type: "email" })
                                            });
                                        }}
                                    />
                                    <div className={styles.edit_icon}
                                        onClick={() => setOpen(true)}>
                                        <span className="icon-edit"></span>
                                    </div>
                                </div>
                                <div className={styles.edit_email_phone}>
                                    <TextInput
                                        label={t("phoneNumberLabel")}
                                        type=""
                                        readOnly={true}
                                        onKeyDown={(e) => keyPress(e)}
                                        value={edit.data.phone_number}
                                        disabled={true}
                                        onChange={(value) => (get_inputs_values_act
                                            (validation({
                                                label: "phone_number",
                                                value, type: "phone_number"
                                            })))} />
                                    <div className={styles.edit_icon}
                                        onClick={() => setOpenPhone(true)}>
                                        <span className="icon-edit"></span>
                                    </div>
                                </div>

                                <TextInput
                                    label={t("residenceAddressLabel")}
                                    type="" value={edit.data.address}
                                    onKeyDown={(e) => keyPress(e)}
                                    onChange={(value) => {
                                        get_inputs_values_act({
                                            label: "address",
                                            data: validation({ value, type: "text" })
                                        });
                                    }}
                                />
                                <TextInput
                                    label={t("postalCodeLabel")}
                                    type="number"
                                    value={edit.data.zip_code}
                                    onKeyDown={(e) => keyPress(e)}
                                    onChange={(value) => {
                                        get_inputs_values_act({
                                            label: "zip_code",
                                            data: validation({ value, type: "zip_code" })
                                        });
                                    }}
                                />
                                <div style={{width:'340px'}} className='d-flex justify-content-between'>
                                    <span className={styles.sendEmailLabel}>{t("sendEmail")}</span>
                                    <SwitchCont
                                        value={sendEmail}
                                        handleChange={handleSendEmail}
                                    />
                                </div>

                            </div>
                        </div>
                        <div className={styles.my_profile_button}>
                            <MainButton title={edit.submitted
                                ? <ClipLoader color="#464646" size={15} />
                                : t("saveLabel")
                            } onClick={() => {
                                edit_my_data(props.token);
                            }} />
                        </div>
                    </div>
                </div> : <div className="w-100 d-flex justify-content-center">
                    <ClipLoader color="#464646" size={15} />
                </div>}
            </main>
        </MainLayout>
        // </div>
    );
}

export default MyProfile;
